import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'
import createLogger from 'vuex/dist/logger'
import config from '@/config'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  strict: !config.env.isProduction,
  plugins: !config.env.NODE_ENV ? [createLogger()] : [],
})
